/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Endpoint_A_SubscriptionInputs */

const en_seo_endpoint_a_subscription = /** @type {(inputs: Seo_Endpoint_A_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. You add US dollars to one prepaid AnyAPI balance and each request draws it down. There is no monthly plan and no minimum, and the same balance pays for every AnyAPI endpoint.`)
};

const zh_hans1_seo_endpoint_a_subscription = /** @type {(inputs: Seo_Endpoint_A_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不需要。你向一个预付费的 AnyAPI 余额充值美元，每个请求从中扣费。没有月度套餐，也没有最低消费，同一个余额可用于所有 AnyAPI 接口。`)
};

const pt_br2_seo_endpoint_a_subscription = /** @type {(inputs: Seo_Endpoint_A_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Você adiciona dólares a um único saldo pré-pago da AnyAPI e cada requisição desconta dele. Não há plano mensal nem mínimo, e o mesmo saldo paga todos os endpoints da AnyAPI.`)
};

const es_seo_endpoint_a_subscription = /** @type {(inputs: Seo_Endpoint_A_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Agregas dólares a un solo saldo prepagado de AnyAPI y cada solicitud descuenta de él. No hay plan mensual ni mínimo, y el mismo saldo paga todos los endpoints de AnyAPI.`)
};

const fr_seo_endpoint_a_subscription = /** @type {(inputs: Seo_Endpoint_A_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Vous ajoutez des dollars US à un solde AnyAPI prépayé unique et chaque requête le débite. Il n’y a ni forfait mensuel ni minimum, et le même solde paie tous les endpoints AnyAPI.`)
};

const de_seo_endpoint_a_subscription = /** @type {(inputs: Seo_Endpoint_A_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Du lädst US-Dollar auf ein Prepaid-AnyAPI-Guthaben, und jede Anfrage bucht davon ab. Es gibt keinen Monatstarif und kein Minimum, und dasselbe Guthaben bezahlt jeden AnyAPI-Endpoint.`)
};

const ru_seo_endpoint_a_subscription = /** @type {(inputs: Seo_Endpoint_A_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет. Вы пополняете один предоплаченный баланс AnyAPI в долларах США, и каждый запрос списывает с него. Ежемесячного тарифа и минимума нет, а один и тот же баланс оплачивает каждый эндпоинт AnyAPI.`)
};

const it_seo_endpoint_a_subscription = /** @type {(inputs: Seo_Endpoint_A_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Aggiungi dollari statunitensi a un unico saldo prepagato AnyAPI e ogni richiesta lo scala. Non c'è un piano mensile né un minimo, e lo stesso saldo paga ogni endpoint AnyAPI.`)
};

/**
* | output |
* | --- |
* | "No. You add US dollars to one prepaid AnyAPI balance and each request draws it down. There is no monthly plan and no minimum, and the same balance pays for e..." |
*
* @param {Seo_Endpoint_A_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_a_subscription = /** @type {((inputs?: Seo_Endpoint_A_SubscriptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_A_SubscriptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_a_subscription(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_a_subscription(inputs)
	if (locale === "es") return es_seo_endpoint_a_subscription(inputs)
	if (locale === "fr") return fr_seo_endpoint_a_subscription(inputs)
	if (locale === "de") return de_seo_endpoint_a_subscription(inputs)
	if (locale === "ru") return ru_seo_endpoint_a_subscription(inputs)
	if (locale === "it") return it_seo_endpoint_a_subscription(inputs)
	return en_seo_endpoint_a_subscription(inputs)
});